// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2yopk","largestCol":"styles_largestCol__26GEn","smallestCol":"styles_smallestCol__3U6mh"};